import { createSlice } from '@reduxjs/toolkit';
import { RequestStatus } from '../../../../shared/enums/request-status';
import { setUserPasswordRequest } from './extra-actions';

type State = {
  status: RequestStatus;
  message: string;
  error: any;
  showError: boolean;
};

const initialState: State = {
  status: RequestStatus.Ideal,
  message: '',
  error: '',
  showError: false,
};

const setUserPasswordSlice = createSlice({
  name: 'setUserPassword',
  initialState,
  reducers: {
    hideError: (state) => {
      state.showError = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setUserPasswordRequest.pending, (state) => {
      state.status = RequestStatus.Pending;
      state.showError = false;
    });
    builder.addCase(setUserPasswordRequest.fulfilled, (state, action) => {
      state.status = RequestStatus.Succeeded;
      state.message = action.payload.message;
    });
    builder.addCase(setUserPasswordRequest.rejected, (state, action) => {
      state.status = RequestStatus.Failed;
      state.error = action.payload;
      state.showError = !action.payload.isHandled;
    });
  },
});

export const { hideError } = setUserPasswordSlice.actions;
export { setUserPasswordRequest };
export default setUserPasswordSlice.reducer;
